import React, { Component } from "react";
import Fade from "react-reveal";
import { ZoomImage } from "../ZoomImage";

class Media extends Component {
    state = { isOpen: false };

    handleShowDialog = () => {
        this.setState({ isOpen: !this.state.isOpen });
        console.log("cliked");
    };

    render() {
        if (!this.props.data) return null;

        const link_drive = this.props.data.dttm.link_drive;
        const link_drive_2026 = this.props.data.dttm.link_drive_2026;
        return (
            <section id="media_dttm" >
                <Fade duration={1000}>
                    <div className="row">
                        <div className="align-center">
                            <h1>
                                <span style={{ color: "#fff", textShadow: "2px 2px 2px #000", fontFamily: 'font-italic-dttm' }}>Media</span>
                            </h1>
                        </div>
                        <br />
                    </div>
                    <div className="row" style={{ textAlign: "center" }}>
                        <div className="two columns"> </div>
                        <div className="four columns" style={{ marginBottom: "30px" }}>
                            <div className="card card-3d" style={{ "border-radius": "8px", "padding": "5px", "padding-top":"50px", "padding-bottom":"50px", "background": "url(../images/dttm/card_background.png)" }}>
                                <h2>Foto dell'edizione 2026 - by Eric G<br />
                                    <a href={link_drive_2026} target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "underline" }}>
                                        clicca qui
                                    </a>
                                </h2>
                            </div>
                        </div>
                        <div className="four columns" style={{ marginBottom: "30px" }}>
                            <div className="card card-3d" style={{ "border-radius": "8px", "padding": "5px", "padding-top":"50px", "padding-bottom":"50px", "background": "url(../images/dttm/card_background.png)" }}>
                                <h2>Foto dell'edizione 2025 - by Eric G<br />
                                    <a href={link_drive} target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "underline" }}>
                                        clicca qui
                                    </a>
                                </h2>
                            </div>
                        </div>
                        <div className="two columns"> </div>
                    </div>

                </Fade>
            </section >
        );
    }
}


export default Media;
